import { MouseEventHandler } from 'react';
import cn from 'classnames';
import { ShoppingCartIcon, CaretRightIcon } from '@phosphor-icons/react';

import { HeroInfoCardData } from './types';

import styles from './HeroInfoCard.module.scss';

export interface HeroInfoCardProps extends HeroInfoCardData {
  href: string;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  onAuxClick?: MouseEventHandler<HTMLAnchorElement>;
}

const HeroInfoCard = ({
  description,
  cta,
  href,
  className,
  onClick,
  onAuxClick,
}: HeroInfoCardProps) => (
  <div className={cn(styles.infoCard, className)}>
    <p className={styles.description}>{description}</p>
    <a
      href={href}
      className={styles.cta}
      onClick={onClick}
      onAuxClick={onAuxClick}
    >
      <ShoppingCartIcon size={16} aria-hidden="true" />
      <span>{cta.label}</span>
      <CaretRightIcon size={8} aria-hidden="true" />
    </a>
  </div>
);

export default HeroInfoCard;
